import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';

export const useConfirmEmailByInvitationMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: recallApi.ConfirmEmailByInvitationResponse) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
}) => {
  return useMutation({
    mutationFn: async ({
      userid,
      token,
    }: {
      userid?: string;
      token: string;
    }) => {
      const query = {
        userid,
      };

      const body = {
        token,
      };

      const response = await recallApi.confirmEmailByInvitation({
        query,
        body,
        throwOnError: true,
      });

      return response.data;
    },
    onSuccess,
    onError,
  });
};
